import { Button } from 'react-bootstrap';
import { useApp } from '../../../hook/app.hook';
import { Question, Section } from '../../../response/test.response';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nKey } from '../../../i18n/i18n.key';

interface ParagraphNavigationProps {
  currentQuestion: Question;
}

const ParagraphNavigationComponent: React.FC<ParagraphNavigationProps> = ({
  currentQuestion,
}) => {
  const { testRes, updateActiveQuestion } = useApp();
  const { t } = useTranslation();

  // Find all questions that share the same paragraph ID
  const getParagraphQuestions = (): Question[] => {
    if (!currentQuestion.paragraph?.id) return [];

    const paragraphQuestions: Question[] = [];

    testRes.sectionList.forEach((section: Section) => {
      section.questionList.forEach((question: Question) => {
        if (question.paragraph?.id === currentQuestion.paragraph?.id) {
          paragraphQuestions.push(question);
        }
      });
    });

    return paragraphQuestions.sort((a, b) => a.index - b.index);
  };

  const paragraphQuestions = getParagraphQuestions();
  const currentQuestionIndex = paragraphQuestions.findIndex(
    (q) => q.id === currentQuestion.id,
  );

  const handlePreviousParagraphQuestion = () => {
    if (currentQuestionIndex > 0) {
      const previousQuestion = paragraphQuestions[currentQuestionIndex - 1];
      updateActiveQuestion(previousQuestion.id);
    }
  };

  const handleNextParagraphQuestion = () => {
    if (currentQuestionIndex < paragraphQuestions.length - 1) {
      const nextQuestion = paragraphQuestions[currentQuestionIndex + 1];
      updateActiveQuestion(nextQuestion.id);
    }
  };

  // Don't render if there's only one question or no paragraph
  if (paragraphQuestions.length <= 1 || !currentQuestion.paragraph?.id) {
    return null;
  }

  return (
    <div className="d-flex align-items-center justify-content-between mb-3 p-2 bg-light rounded">
      <div className="d-flex align-items-center">
        <span className="text-muted me-2">
          {t(I18nKey.PARAGRAPH_QUESTIONS_TEXT)}: {currentQuestionIndex + 1} /{' '}
          {paragraphQuestions.length}
        </span>
      </div>
      <div className="d-flex gap-2">
        <Button
          variant="outline-primary"
          size="sm"
          onClick={handlePreviousParagraphQuestion}
          disabled={currentQuestionIndex === 0}
          className="d-flex align-items-center"
        >
          <img
            src="/images/prev-icon.svg"
            alt=""
            height="12"
            className="me-1"
          />
          {t(I18nKey.PREVIOUS_TEXT)}
        </Button>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={handleNextParagraphQuestion}
          disabled={currentQuestionIndex === paragraphQuestions.length - 1}
          className="d-flex align-items-center"
        >
          {t(I18nKey.NEXT_TEXT)}
          <img
            src="/images/next-icon.svg"
            alt=""
            height="12"
            className="ms-1"
          />
        </Button>
      </div>
    </div>
  );
};

export default memo(ParagraphNavigationComponent);
